import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=fd5b7e18&"
import script from "./Points.vue?vue&type=script&lang=js&"
export * from "./Points.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd5b7e18')) {
      api.createRecord('fd5b7e18', component.options)
    } else {
      api.reload('fd5b7e18', component.options)
    }
    module.hot.accept("./Points.vue?vue&type=template&id=fd5b7e18&", function () {
      api.rerender('fd5b7e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/Points.vue"
export default component.exports